import { resolveComponent as _resolveComponent, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af7bb7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "jr-flex jr-fixed jr-w-full jr-h-full" }
const _hoisted_2 = { class: "jr-px-6.252 jr-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "居住地ランキング", -1))
const _hoisted_4 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "勤務地ランキング", -1))
const _hoisted_6 = { class: "jr-absolute jr-h-0.5 jr-w-full jr-bottom-0 jr-left-0 jr-bg-blue-light" }
const _hoisted_7 = { class: "jr-px-5 jr-pt-6 jr-pb-7.5 jr-overflow-scroll jr-h-full" }
const _hoisted_8 = ["onMouseover"]
const _hoisted_9 = { class: "jr-px-5 jr-pt-6 jr-pb-7.5 jr-overflow-scroll jr-h-full" }
const _hoisted_10 = ["onMouseover"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RankingColors = _resolveComponent("RankingColors")!
  const _component_UIGoogleMap = _resolveComponent("UIGoogleMap")!
  const _component_AreaSearchFilter = _resolveComponent("AreaSearchFilter")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UIGoogleMap, {
      onLoad: _ctx.handleMapLoad,
      right: _ctx.captureClip ? 336 : _ctx.filterMinimum ? 390 : 620,
      "max-zoom": _ctx.polygonMaxZoom,
      class: _normalizeClass(["jr-absolute jr-w-full", { 'content': !_ctx.captureClip, 'jr-h-screen': _ctx.captureClip }])
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_RankingColors, {
          class: _normalizeClass(["transition-indicator jr-absolute jr-bottom-3.9", { 'jr-shadow-lg': !_ctx.captureClip }]),
          style: _normalizeStyle({ left: _ctx.captureClip ? '10px' : _ctx.sbMinimum ? '74px' : '250px' })
        }, null, 8, ["class", "style"]), [
          [_vShow, _ctx.showColors]
        ])
      ]),
      _: 1
    }, 8, ["onLoad", "right", "max-zoom", "class"]),
    _createElementVNode("div", {
      class: _normalizeClass(["jr-w-area-worker transition jr-fixed jr-bg-white", { 'content jr-z-10': !_ctx.captureClip, 'jr-h-screen jr-pt-18 jr-z-50': _ctx.captureClip }]),
      style: _normalizeStyle({ right: _ctx.captureClip ? '0' : _ctx.filterMinimum ? '60px' : '292px' })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["jr-relative jr-text-sm jr-font-medium jr-p-2.5 jr-cursor-pointer", {
                'jr-font-bold jr-text-blue-light' : _ctx.activeTab === _ctx.TabType.ResidencePlace,
                'jr-font-medium jr-text-gray': _ctx.activeTab !== _ctx.TabType.ResidencePlace
             }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTabChange(_ctx.TabType.ResidencePlace)))
        }, [
          _hoisted_3,
          _withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [
            [_vShow, _ctx.activeTab === _ctx.TabType.ResidencePlace]
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["jr-relative jr-text-sm jr-font-medium jr-p-2.5 jr-cursor-pointer", {
                'jr-font-bold jr-text-blue-light' : _ctx.activeTab === _ctx.TabType.WorkLocation,
                'jr-font-medium jr-text-gray': _ctx.activeTab !== _ctx.TabType.WorkLocation
             }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTabChange(_ctx.TabType.WorkLocation)))
        }, [
          _hoisted_5,
          _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
            [_vShow, _ctx.activeTab === _ctx.TabType.WorkLocation]
          ])
        ], 2)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.residents, (resident, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: resident.name,
            class: _normalizeClass(["jr-px-7 jr-py-2.5 jr-text-base jr-cursor-pointer jr-border-blue-light jr-rounded-lg jr-mb-px jr-box-content", {
               'jr-border jr-bg-primary-light': _ctx.hoveringCity !== undefined && _ctx.hoveringCity === resident.name
             }]),
            onMouseover: ($event: any) => (_ctx.handleHoverCity(resident.name)),
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleHoverCity(undefined)))
          }, [
            _createElementVNode("span", null, _toDisplayString(index + 1) + ". ", 1),
            _createElementVNode("span", null, _toDisplayString(resident.name), 1),
            _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(resident.percentage) + "%)", 513), [
              [_vShow, resident.percentage]
            ])
          ], 42, _hoisted_8))
        }), 128))
      ], 512), [
        [_vShow, _ctx.activeTab === _ctx.TabType.ResidencePlace]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLocations, (wl, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: wl.name,
            class: _normalizeClass(["jr-px-7 jr-py-2.5 jr-text-base jr-cursor-pointer jr-border-blue-light jr-rounded-lg jr-mb-px jr-box-content", {
               'jr-border jr-bg-primary-light': _ctx.hoveringCity !== undefined && _ctx.hoveringCity === wl.name
             }]),
            onMouseover: ($event: any) => (_ctx.handleHoverCity(wl.name)),
            onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleHoverCity(undefined)))
          }, [
            _createElementVNode("span", null, _toDisplayString(index + 1) + ". ", 1),
            _createElementVNode("span", null, _toDisplayString(wl.name), 1),
            _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(wl.percentage) + "%)", 513), [
              [_vShow, wl.percentage]
            ])
          ], 42, _hoisted_10))
        }), 128))
      ], 512), [
        [_vShow, _ctx.activeTab === _ctx.TabType.WorkLocation]
      ])
    ], 6),
    _createVNode(_component_AreaSearchFilter, {
      onSearch: _ctx.handleSearch,
      onResize: _ctx.handleFilterResize
    }, null, 8, ["onSearch", "onResize"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}